import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import uploadIcon from '../../assets/paper_upload.svg';
import cancelIcon from '../../assets/cancel_button.svg';
import { pxToRem } from '../../utils/pxToRem';

interface IImagePicker {
  onFilePicked: (item: File[]) => void;
  initialValue?: Array<string>;
  multiple?: boolean;
}

export const ImagePicker: FC<IImagePicker> = ({
  onFilePicked,
  initialValue = [],
  multiple = true
}) => {
  const imgRef = useRef<HTMLInputElement>(null);
  const [imageUpload, setImageUpload] = useState<File[]>();
  const [imagePreview, setImagePreview] = useState<string[]>([...initialValue]);

  const handleImageChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.files) {
      const files = e.target.files;
      setImageUpload(Array.from(files));
      onFilePicked(Array.from(files));
    } else {
      setImageUpload([]);
    }
  };

  useEffect(() => {
    if (imageUpload) {
      imageUpload.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview((prev) => [...prev, reader.result as string]);
        };
        reader.readAsDataURL(file);
      });
    }
  }, [imageUpload]);

  const handleImageClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.preventDefault();
    imgRef.current?.click();
  };

  const removeSelectedImage = () => {
    setImagePreview([]);
    setImageUpload([]);
  };
  return (
    <>
      <InputImage
        type="file"
        ref={imgRef}
        multiple={multiple}
        accept="image/*"
        onChange={handleImageChange}
      />
      <ImageUploadContainer>
        {imagePreview.length ? (
          <ViewImageUploadWrapper>
            <ImageDetails>
              {imagePreview.map((image, index) => (
                <ImageView key={index} src={image} alt="" />
              ))}
              {/* <ImageFileName>{imageUpload?.name}</ImageFileName> */}
            </ImageDetails>
            <CancelImage
              src={cancelIcon}
              alt=""
              onClick={removeSelectedImage}
            />
          </ViewImageUploadWrapper>
        ) : (
          <ImageUploadWrapper>
            <ImageUploadPlaceholder onClick={handleImageClick}>
              <IconPlaceholder src={uploadIcon} />
              <PlaceholderHeading>Upload pictures</PlaceholderHeading>
              <PlaceholderCaption>
                Images must be less than <BoldText>5MB</BoldText> in size: ;
              </PlaceholderCaption>
            </ImageUploadPlaceholder>
          </ImageUploadWrapper>
        )}
      </ImageUploadContainer>
    </>
  );
};
const InputImage = styled.input`
  display: none;
`;
const ImageUploadContainer = styled.div``;
const ImageUploadWrapper = styled.div`
  border: 1px dashed #d6d6d6;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  height: 100px;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 15px;
  width: 100%;
`;

const ImageUploadPlaceholder = styled.div``;
const IconPlaceholder = styled.img``;
const PlaceholderHeading = styled.h6`
  font-size: ${pxToRem(12)};
  line-height: 120%;
  color: #32324b;
`;
const PlaceholderCaption = styled.p`
  font-size: ${pxToRem(12)};
  line-height: 120%;
  color: #a1a1a1;
`;

const ViewImageUploadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dashed #d6d6d6;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 15px;
`;
const ImageDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;
const ImageView = styled.img`
  width: 80px;
  height: 80px;
  border: 0.3px solid #a1a1a1;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 24px;
`;

// const ImageFileName = styled.p`
//   font-size: 16px;
//   line-height: 140%;
//   color: #32324b;
//   margin: 0;
// `;

const CancelImage = styled.img``;

const BoldText = styled.span`
  color: #32324b;
  font-weight: 500;
`;
